import { toast } from "react-toastify";
import { CALL_SCHEDULED_REPORT } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const fetchCallScheduledReportTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${CALL_SCHEDULED_REPORT.GET_METADATA}/${data?._Id}`
            : `${CALL_SCHEDULED_REPORT.GET_METADATA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitCallScheduledReportFilterData = async (data = {}) => {
    try {
        const response = await POST(CALL_SCHEDULED_REPORT.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
